import { render } from "./HorsePreviewOwners.vue?vue&type=template&id=63438398"
import script from "./HorsePreviewOwners.vue?vue&type=script&lang=js"
export * from "./HorsePreviewOwners.vue?vue&type=script&lang=js"

import "./HorsePreviewOwners.vue?vue&type=style&index=0&id=63438398&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__